import { Component, computed, inject, input, output, signal } from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NavButtonComponent } from '../nav-button/nav-button';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { InstructionPopupItem } from '../../models/popup.model';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-select-photo-popup',
  templateUrl: './select-photo-popup.html',
  styleUrls: ['./select-photo-popup.scss'],
  imports: [
    FormsModule,
    NzModalModule,
    NavButtonComponent,
    NzRadioModule,
    NzIconModule,
    NzImageModule,
  ],
})
export class SelectPhotoPopupComponent {
  header = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  instructions = input<InstructionPopupItem[]>([]);

  closeEvent = output<void>();
  save = output<void>();

  readonly i18n = inject(I18nService);
  private readonly ui = inject(UiService);

  radioValue = signal<any>(null);

  isMobile = computed<boolean>(() => this.ui.IsMobile());
  formInvalid = computed<boolean>(() => this.radioValue() == null);

  onClose(): void {
    this.closeEvent.emit();
  }

  onSave(): void {
    // emit save only when form is valid (radioValue selected)
    if (!this.formInvalid()) {
      this.save.emit(this.radioValue());
    }
  }

  onRadioChange(value: any): void {
    this.radioValue.set(value);
  }
}
